<template>
  <v-combobox
    v-model="valueComputed"
    :items="tags"
    :rules="rules"
    :label="label"
    chips
    small-chips
    multiple
  />
</template>

<script>
import QuilityAPI from '../../store/API/QuilityAPI';

export default {
  props: {
    value: { type: Array, default: () => [] },
    rules: { type: Array, default: () => [] },
    label: { type: String, default: 'Subjects' },
  },

  data() {
    return {
      tags: [],
    }
  },

  computed: {
    valueComputed: {
      get() { return this.$props.value },
      set(value) { this.$emit('input', value) }
    }
  },

  async mounted() {
    this.tags = (await QuilityAPI.getMarketingResourcesTagsList())
  },
}
</script>
